import React from 'react'
import PropTypes from 'prop-types'
import useStyles from './styles'

// Pill toggle built on native radio inputs: the browser provides the radio
// group semantics, arrow key navigation (Left/Right/Up/Down) and Tab stop, and
// the checked face follows `input:checked`. Pass `labelledBy` (id of a visible
// label) or `label` (aria-label) to name the group.
const SegmentedControl = ({
  name,
  options,
  value,
  onChange,
  label,
  labelledBy,
}) => {
  const classes = useStyles()

  return (
    <div
      role="radiogroup"
      aria-label={labelledBy ? undefined : label}
      aria-labelledby={labelledBy}
      className={classes.segmented}
    >
      {options.map(option => (
        <label key={option.value} className={classes.segment}>
          <input
            type="radio"
            name={name}
            value={option.value}
            checked={value === option.value}
            onChange={() => onChange(option.value)}
            className={classes.segmentInput}
          />
          <span className={classes.segmentFace}>{option.label}</span>
        </label>
      ))}
    </div>
  )
}

SegmentedControl.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  labelledBy: PropTypes.string,
}

export default SegmentedControl
